import { ruleFieldFromDto } from "./ruleGroupsMapper";

export const ruleFromDto = (dto = {}) => ({
  id: dto.id,
  field: ruleFieldFromDto(dto.field),
  operator: dto.operator,
  value: dto.value,
  active: dto.active,
});

export const ruleCreateToDto = (data = {}) => ({
  field: data.field,
  operator: data.operator,
  value: data.value,
});

export const ruleUpdateToDto = (data = {}) => ({
  id: data.id,
  ...ruleCreateToDto(data),
});
